import './Event.css';
import ExitButton from '../common/ExitButton';
import InfoArea from '../ContentView/InfoArea';

// EventModal component to display event details

function EventModal({ event, onClose }) {
  if (!event) return null;

  // Helper to format the date
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString();
  };

  // Helper to format the time
  const formatTime = (timeStr) => {
    return timeStr.slice(0, 5);
  };

  return (
    <div className="EventOverlay" onClick={onClose}>
      <div className="EventWrapper" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ExitButton onClick={onClose} />
        </div>

        <h1>{event.title}</h1>

        {event.startDate && <p><b>Start:</b> {formatDate(event.startDate)}</p>}
        {event.endDate && <p><b>Ende:</b> {formatDate(event.endDate)}</p>}

        {(event.startTime || event.endTime) && (
          <p>
            {event.startTime && event.endTime
              ? `${formatTime(event.startTime)} – ${formatTime(event.endTime)} Uhr`
              : event.startTime
                ? `ab ${formatTime(event.startTime)} Uhr`
                : `bis ${formatTime(event.endTime)} Uhr`}
          </p>
        )}

        {event.description && (
          <InfoArea
            title="Informationen"
            value={event.description}
          />
        )}

        {/* If they exist, display DayTimeOverrides */}
        {event.dayTimeOverride && event.dayTimeOverride.length > 0 && (
          <div className="daytime-overrides">
            <h2>Besondere Zeiten</h2>
            <ul>
              {event.dayTimeOverride.map((override) => (
                <li key={override.id}>
                  <strong>{formatDate(override.date)}</strong>
                  <br />
                  {override.startTime && override.endTime
                    ? `${formatTime(override.startTime)} – ${formatTime(override.endTime)} Uhr`
                    : `ab ${formatTime(override.startTime)} Uhr`}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default EventModal;